export const NEW_USER = {
  // NewUserJoin elements
  JOIN_BUTTON: 'new-user-join-button',
  LOGO_IMAGE: 'new-user-join-logo',
  ORG_ICON: 'new-user-join-org-icon',

  // NewUserAccountVerified elements
  VERIFIED_LOGO: 'new-user-verified-logo',
  VERIFIED_TICK: 'new-user-verified-tick'
} as const;
